(function () {
    

    const wrapperGrid = document.querySelector(".wp-block-plblockstt-product-grid");
    if (!wrapperGrid) return;

    wrapperGrid.querySelectorAll('.filterGroup .titleFilter').forEach(function(item){
        item.addEventListener('click',function(){
            if(item.classList.contains('active')){
                item.classList.remove('active');
            }else{
                wrapperGrid.querySelectorAll('.filterGroup .titleFilter').forEach(function(item){
                    item.classList.remove('active');
                });
                item.classList.add('active');
            }
        });
        
    });


})();;